import { Covenants } from "types/Covenants";
import { createCustomAction } from "typesafe-actions";

const COVENANTS_DATA_LOAD = "COVENANTS/COVENANTS_DATA_LOAD";
const COVENANTS_DATA_LOAD_SUCCESS = "COVENANTS/COVENANTS_DATA_LOAD_SUCCESS";
const COVENANTS_DATA_LOAD_FAIL = "COVENANTS/COVENANTS_DATA_LOAD_FAIL";
const COVENANTS_COUNT_DATA_LOAD = "COVENANTS/COVENANTS_COUNT_DATA_LOAD";
const COVENANTS_COUNT_DATA_LOAD_SUCCESS = "COVENANTS/COVENANTS_COUNT_DATA_LOAD_SUCCESS";
const COVENANTS_COUNT_DATA_LOAD_FAIL = "COVENANTS/COVENANTS_COUNT_DATA_LOAD_FAIL";

export const load = createCustomAction(COVENANTS_DATA_LOAD, (type) => () => ({
  type,
}));

export const loadSuccess = createCustomAction(
  COVENANTS_DATA_LOAD_SUCCESS,
  (type) => (data?: Covenants[]) => ({
    type,
    data,
  })
);

export const loadFail = createCustomAction(
  COVENANTS_DATA_LOAD_FAIL,
  (type) => (error?: string) => ({
    type,
    error,
  })
);

export const loadCount = createCustomAction(COVENANTS_COUNT_DATA_LOAD, (type) => () => ({
  type,
}));

export const loadCountSuccess = createCustomAction(
  COVENANTS_COUNT_DATA_LOAD_SUCCESS,
  (type) => (data?: number) => ({
    type,
    data,
  })
);

export const loadCountFail = createCustomAction(
  COVENANTS_COUNT_DATA_LOAD_FAIL,
  (type) => (error?: string) => ({
    type,
    error,
  })
);
